import React, { useState, useEffect } from 'react';
import { CheckCircle, Circle, ChevronDown, ChevronUp } from 'lucide-react';
import { Card, Button, Typography } from 'antd';
import { useTranslation, Trans } from 'react-i18next';
import ManagersImg from '../../../assets/otf-impact-success-managers.png';

const { Title, Text } = Typography;

const LOCAL_STORAGE_KEY = 'checklist_todos';

const CheckList = () => {
    const { t, i18n } = useTranslation();
    const [activePanel, setActivePanel] = useState(null);
    const [todos, setTodos] = useState([]);

    useEffect(() => {
        const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (stored) {
            setTodos(JSON.parse(stored));
        } else {
            setTodos([
                { id: 1, completed: false },
                { id: 2, completed: false },
                { id: 3, completed: false },
                { id: 4, completed: false },
            ]);
        }
    }, []);

    useEffect(() => {
        if (todos.length) {
            localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(todos));
        }
    }, [todos]);

    const toggleComplete = (id) => {
        setTodos((prevTodos) =>
            prevTodos.map((todo) =>
                todo.id === id ? { ...todo, completed: !todo.completed } : todo
            )
        );
    };

    const handleToggle = (id) => {
        setActivePanel(activePanel === id ? null : id);
    };

    return (
        <div style={{ padding: 20, backgroundColor: '#f6f6f6', borderRadius: 8, boxShadow: '0 3px 8px rgba(0,0,0,.2)' }}>
            <div style={{ maxWidth: 1200, margin: '0 auto' }}>
                <Title level={2} style={{ textAlign: 'center', marginBottom: 38, fontSize: 20 }}>
                    {t('home.checklist.title')}
                </Title>

                {todos.map((todo) => (
                    <Card
                        key={todo.id}
                        style={{ marginBottom: 24, borderRadius: 8, boxShadow: '0px 4px 10px rgba(0,0,0,0.1)' }}
                        bodyStyle={{ padding: 12 }}
                        hoverable
                    >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Button
                                type='text'
                                icon={
                                    todo.completed ? (
                                        <CheckCircle style={{ color: 'green', fontSize: 20 }} />
                                    ) : (
                                        <Circle style={{ color: 'gray', fontSize: 20 }} />
                                    )
                                }
                                onClick={() => toggleComplete(todo.id)}
                                style={{ marginRight: 16 }}
                            />
                            <div style={{ flexGrow: 1 }}>
                                <Title
                                    level={4}
                                    style={{
                                        fontSize: 14,
                                        margin: 0,
                                        textDecoration: todo.completed ? 'line-through' : 'none',
                                        color: todo.completed ? 'gray' : 'inherit',
                                    }}
                                >
                                    {t(`home.checklist.items.${todo.id}.title`)}
                                </Title>
                            </div>
                            <Button
                                type="text"
                                icon={
                                    activePanel === todo.id ? <ChevronUp /> : <ChevronDown />
                                }
                                onClick={() => handleToggle(todo.id)}
                            />
                        </div>

                        {activePanel === todo.id && (
                            <div style={{ margin: '12px auto' }}>
                                <div style={{ fontSize: '14px', marginTop: '10px' }}>

                                    {
                                        todo.id === 1 ? (
                                            <>
                                                <Text>{t(`home.checklist.items.${todo.id}.desc`)}</Text>
                                                <div style={{ marginTop: 12 }}>
                                                    <iframe
                                                        width="100%"
                                                        height="315"
                                                        src={
                                                             i18n.language === 'fr'
                                                                    ? 'https://www.youtube.com/embed/wL5CFbBEySk?si=eheKua9yAMQIuvKQ'
                                                                    : 'https://www.youtube.com/embed/q_GpRr5-bWQ?si=0gm-lPMGZWp5BJ9u'
                                                        }
                                                        title="Training Video"
                                                        frameBorder="0"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        referrerPolicy="strict-origin-when-cross-origin"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                            </>

                                        ) : todo.id === 2 ? (
                                        <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                                            <img
                                                src={ManagersImg}
                                                alt='Managers'
                                                style={{ height: 160 }}
                                            />
                                            <div>
                                                <Trans
                                                    i18nKey={`home.checklist.items.${todo.id}.desc`}
                                                    components={{
                                                        1: <strong />,
                                                        2: <a href="mailto:yof_support@crg.ca" style={{ color: "#467886", textDecoration: "none", fontWeight: 600 }} />,
                                                        br: <br />
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    ) : todo.id === 3 ? (
                                        <Trans
                                            i18nKey={`home.checklist.items.${todo.id}.desc`}
                                            components={[
                                                <></>,
                                                <a href="/surveys" style={{ color: '#467886', fontWeight: 'bold', textDecoration: 'none' }} />
                                            ]}
                                        />
                                    ) : todo.id === 4 ? (
                                            <>
                                                <Text>{t(`home.checklist.items.${todo.id}.desc`)}</Text>
                                                <div style={{ marginTop: 12 }}>
                                                    <iframe
                                                        width="100%"
                                                        height="315"
                                                        src={
                                                            i18n.language === 'fr'
                                                                ? 'https://www.youtube.com/embed/PKLlhurFZ6E'
                                                                : 'https://www.youtube.com/embed/_oYIVBoM9o8'
                                                        }
                                                        title="Explore Reporting Features"
                                                        frameBorder="0"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        referrerPolicy="strict-origin-when-cross-origin"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                            </>
                                    ) : (
                                        <Text>{t(`home.checklist.items.${todo.id}.desc`)}</Text>
                                    )}
                                </div>
                            </div>
                        )}
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default CheckList;